import { storybookReady } from '../../../core/js/utils'

let storybook, settings

(async function () {
  storybook = await storybookReady()

  settings = storybook ? {
    debug: true
  } : (window.brandPage || {})

  document.querySelectorAll('.Intro').forEach(item => {
    new Intro(item)
  })
})()

class Intro {
  constructor (element) {
    settings.debug && console.log('Intro')

    this.element = element

    this.element.querySelectorAll('form').forEach(form => {
      form.addEventListener('submit', (event) => {
        event.preventDefault()
        this.handleSubmit(event.currentTarget)
      })
    })
  }

  handleSubmit(form) {
    settings.debug && console.log('handleSubmit')

    fetch(form.action + '?async=true', {
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        Accept: 'text/html',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(new FormData(form)).toString()
    })
    .then(response => {
      if (response.status === 200) {
        return response.text()
      } else {
        throw new Error("Not 200 response")
      }
    })
    .then(text => {
      this.element.outerHTML = text
    })
  }
}
